var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeftMainBanner = function SvgArrowLeftMainBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.74 39.999 21.23-29.09c.175-.234.313-.513.407-.819.093-.306.14-.634.138-.964a3.23 3.23 0 0 0-.15-.962 2.65 2.65 0 0 0-.417-.81 1.918 1.918 0 0 0-.619-.533 1.468 1.468 0 0 0-.724-.174 1.492 1.492 0 0 0-.72.211 1.983 1.983 0 0 0-.603.564l-22.5 30.834c-.34.466-.53 1.092-.53 1.743s.19 1.277.53 1.743l22.5 30.834c.171.24.376.43.603.564.227.133.472.205.72.211.247.006.494-.053.724-.174.23-.122.441-.303.619-.534.178-.23.32-.505.416-.81a3.23 3.23 0 0 0 .151-.96 3.244 3.244 0 0 0-.139-.965 2.683 2.683 0 0 0-.406-.819l-21.23-29.09Z",
    fill: "#fff",
    opacity: 0.2
  })));
};
export default SvgArrowLeftMainBanner;